import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppLayout from "./layout/AppLayout";
import AdminLayout from "./layout/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import "./App.css";
import Analysis from "./pages/Analysis";
import Insights from "./pages/Insights";
import Progression from "./pages/Progression";
import Biomarkers from "./pages/Biomarkers";
import MedicalUsers from "./components/Admin/MedicalUsers/MedicalUsers";
import Profile from "./components/Profile/Profile";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}

        {/* Protected routes */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="analysis" element={<Analysis />} />
          <Route path="progression" element={<Progression />} />
          <Route path="insights" element={<Insights />} />
          <Route path="biomarkers" element={<Biomarkers />} />
          <Route path="reports" element={<Reports />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Admin routes - Only accessible by admins */}
        <Route
          element={
            <AdminProtectedRoute>
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/analysis" element={<Analysis />} />
          <Route path="/admin/progression" element={<Progression />} />
          <Route path="/admin/insights" element={<Insights />} />
          <Route path="/admin/biomarkers" element={<Biomarkers />} />
          <Route path="/admin/reports" element={<Reports />} />
          <Route path="/admin/users" element={<MedicalUsers />} />
          <Route path="/admin/profile" element={<Profile />} />
        </Route>

        {/* Catch-all route for unauthorized admin access */}
        <Route path="/admin/*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}
